import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

const screenAdapter = createEntityAdapter();
const initialState = screenAdapter.getInitialState({
  scrollPosition: 0,
});

export const screenSlice = createSlice({
  name: "screen",
  initialState,
  reducers: {
    setScrollPosition: (state, { payload }) => {
      const { scrollPosition } = payload;
      state.scrollPosition = scrollPosition;
      return state;
    },
    resetScreenState: () => initialState,
  },
  extraReducers: {},
});

export const { setScrollPosition, resetScreenState } = screenSlice.actions;

export default screenSlice.reducer;
